import {makeAutoObservable, toJS} from 'mobx';
import {RootStore} from './RootStore';
import AdminApiManager from 'services/API/AdminApi/AdminApiManager';
import {StudentData} from 'services/API/AdminApi/AdminApiModels';
import {PersonalData} from 'models/Admin';

export interface IAdminTeachersStore {
  teachers: StudentData[];
  fetchTeachers: () => Promise<void>;
  updateTeachers: () => Promise<void>;
}

const EMPTY_TEACHER = {
  name: '',
  surname: '',
  email: '',
  id: '',
  tenantId: '',
  role: '',
  image: '',
};

export class AdminTeachersStore implements IAdminTeachersStore {
  private adminApiManager = new AdminApiManager();
  private rootStore: RootStore;

  teachers: StudentData[] = [EMPTY_TEACHER];

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;

    makeAutoObservable(this);
  }
  setTeachers = (data: StudentData[]) => {
    this.teachers = data;
  };

  setField = (value: string, arrIndex: number, fieldType: string) => {
    let key = fieldType as keyof StudentData;
    this.teachers[arrIndex][key] = value;
  };

  deleteTeacher = (deletable: PersonalData) => {
    let filteredData = this.teachers.filter(item => item !== deletable);
    this.setTeachers(filteredData);
  };

  addEmptyTeacher = () => {
    let item: StudentData = EMPTY_TEACHER;
    this.addTeacher(item);
  };

  addTeacher = (item: StudentData) => {
    let newFlatList = [...this.teachers];
    newFlatList.push(item);
    this.setTeachers(newFlatList);
  };

  fetchTeachers = async () => {
    this.rootStore.loaderStore.startLoading();
    try {
      this.adminApiManager.getTeachers().then(result => {
        this.setTeachers(result);
      });
    } catch (error) {
      console.log(error);
    } finally {
      this.rootStore.loaderStore.stopLoading();
    }
  };

  updateTeachers = async () => {
    this.rootStore.loaderStore.startLoading();

    try {
      let teachers = toJS(this.teachers);
      await this.adminApiManager.updateTeachers(teachers);
      await this.fetchTeachers();
    } catch (error) {
      console.log(error);
    } finally {
      this.rootStore.loaderStore.stopLoading();
    }
  };
}
